// extracted by mini-css-extract-plugin
export var cardTitle = "_hv-1";
export var commentBubble = "_hv-e";
export var commentForm = "_hv-a";
export var commentInput = "_hv-b";
export var commentLabel = "_hv-d";
export var commentPrompt = "_hv-9";
export var csatCard = "_hv-0";
export var feedbackSection = "_hv-7";
export var starDisabled = "_hv-6";
export var starEmpty = "_hv-5";
export var starFilled = "_hv-4";
export var starWrapper = "_hv-3";
export var starsContainer = "_hv-2";
export var submittedComment = "_hv-c";
export var thankYouText = "_hv-8";